<template>
  <div
    class="weekday"
    v-if="dayEvents.length !== 0"
  >
    <h2 class="weekday__title">{{ title }}</h2>
    <Event
      v-for="event in dayEvents"
      :key="event.id"
      :start="event.start"
      :end="event.end"
      :title="event.title"
      :location="event.location"
      :leftDetail="event.left_detail"
      :rightDetail="event.right_detail"
      :description="event.description"
      :image="event.image"
      :thumbnail="event.thumbnail"
    />
  </div>
</template>

<script>
import moment from 'moment';
import Event from './Event';

export default {
  name: 'Weekday',
  props: [
    'weekIso',
    'weekDay',
    'weekEvents',
  ],
  computed: {
    title: function () {
      return moment.utc(this.weekIso).add(this.weekDay, 'day').format("dddd Do MMMM YYYY");
    },
    dayEvents: function () {
      if (!this.weekEvents) {
        return [];
      }
      return this.weekEvents.filter(
        (event) => moment.utc(event.start).weekday() === this.weekDay
      );
    }
  },
  components: {
    Event
  }
}
</script>

<style lang="scss" scoped>
@import './weekday';
</style>
